import { Suspense } from 'react';

import { PageTitle } from '@components/PageTitle';
import { Skeleton } from '@components/ui/skeleton';

import List from './List';

export default function DrugsRoot() {
  return (
    <div>
      <PageTitle hasBackButton title="Medicamentos" />

      <Suspense
        fallback={
          <div>
            <Skeleton className="ml-auto h-10 max-w-96" />
            <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2">
              {new Array(20).fill(0).map((_, index) => (
                <Skeleton className={`h-16 w-full`} key={index} />
              ))}
            </div>
          </div>
        }>
        <List />
      </Suspense>
    </div>
  );
}
